export const ENTITY_MANAGEMENT = "/entity_management";
export const ENTITY_MANAGEMENT_ADVANCED_SEARCH =
  "/entity_management/advanced-search";

export const TASK_MANAGEMENT = "/task-management";
